import React from 'react';
import CreateProfileView from '#modules/profileSelection/CreateProfileView';
import ChooseProfileView from '#modules/profileSelection/ChooseProfileView';
import EditProfileView from '#modules/profileSelection/EditProfileView';
import {
  ProfileNavigationProvider,
  useProfileNavigation,
  ProfileViews,
} from '#modules/profileSelection/useProfileNavigationContext';

const ProfileSelection = () => {
  const { profileView } = useProfileNavigation();

  if (profileView === ProfileViews.SELECT_PROFILE) {
    return <ChooseProfileView />;
  }

  if (profileView === ProfileViews.CREATE_PROFILE) {
    return <CreateProfileView />;
  }

  if (profileView === ProfileViews.EDIT_PROFILE) {
    return <EditProfileView />;
  }
};

const ProfileSection = () => {
  return (
    <ProfileNavigationProvider>
      <ProfileSelection />
    </ProfileNavigationProvider>
  );
};

export default ProfileSection;
